<template>
  <b-modal id="preview_timesheet_file_modal" ref="preview_timesheet_file_modal" hide-footer no-close-on-esc no-close-on-backdrop>
    <div slot="modal-header" class="mh">
      <div id="mh-text">
        <!-- Different modal header depending on type file being uploaded for -->
        <h1><i class="fas fa-file-upload"></i> &nbsp; <span>Preview Uploaded Timesheet File</span></h1>
        <p id="mh-info">Preview your timesheet, information uploaded using a file from external software</p>
      </div>
      <button v-if="!saving" id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
    </div>

    <div class="row">
      <div class="col-12">
        <p>Below is a preview showing the values which will be imported from the file that you have just uploaded.</p>
      </div>
    </div>

    <div class="preview-container">
      <table class="table">
        <thead>
        <tr>
          <th>Ref</th>
          <th>Full Name</th>
          <th class="rotate" v-for="location in locations">
            <div class="capsule">
              <span>{{ location }}</span>
            </div>
          </th>
          <th>Total Additions</th>
          <th>Total Deductions</th>
          <th class="text-right">Total</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="worker in this.$store.state.client_timesheets.timesheet_preview_info">
          <td>{{ worker.sage_ref }}</td>
          <td>{{ worker.first_name }} {{ worker.surname }}</td>
          <td class="text-center" v-for="location in locations">
            <span v-if="worker.timesheet_location === location">{{ worker.total_price | currency }}</span>
          </td>
          <td>{{ calcWorkerTotalAdditions(worker) | currency }}</td>
          <td>{{ calcWorkerTotalDeductions(worker) | currency }}</td>
          <td class="text-right">{{ calcWorkerTotal(worker) | currency }}</td>
        </tr>
        </tbody>
        <tfoot>
        <tr>
          <td></td>
          <td></td>
          <td class="text-center font-weight-bold" v-for="location in locations">
            {{ getLocationTotal(location) | currency }}
          </td>
          <td>{{ calcTotalAdditions() | currency }}</td>
          <td>{{ calcTotalDeductions() | currency }}</td>
          <td class="text-right font-weight-bold">{{ getImportTotal() | currency }}</td>
        </tr>
        </tfoot>
      </table>
    </div>

    <div class="row mt-3 mb-3 justify-content-center align-items-center">
      <div class="font-weight-bold my-auto mr-2">Pay your workers fee:</div>
      <div>
        <BootstrapToggle
          v-model="payWorkerFee"
          id="pay_worker_fee"
          name="pay_worker_fee"
          :options="{ on: 'Yes', off: 'No' }"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <button class="orcaBtn grey_bg" @click.prevent="cancelImport">Cancel</button>
      </div>
      <div class="col-6">
        <button class="orcaBtn" @click.prevent="importTimesheets">Import Timesheets</button>
      </div>
    </div>

  </b-modal>
</template>

<script>
import BootstrapToggle from 'vue-bootstrap-toggle';

export default {
  name: "timesheet_file_upload_preview_table",
  components: {
    BootstrapToggle,
  },
  data() {
    return {
      payWorkerFee: false,
      saving: false,
      locations: []
    }
  },
  beforeMount() {
    let preview_info = this.$store.state.client_timesheets.timesheet_preview_info;
    for (let i = 0; i < preview_info.length; i++) {
      if (!this.locations.includes(preview_info[i].timesheet_location)) {
        this.locations.push(preview_info[i].timesheet_location);
      }
    }
  },
  methods: {
    hideModal() {
      //this.$refs.preview_timesheet_file_modal.hide();
      this.$store.commit('HIDE_TIMESHEET_FILE_UPLOAD_PREVIEW');
    },
    calcWorkerTotalAdditions(worker) {
      return worker.pre_tax_adds + worker.post_tax_adds;
    },
    calcWorkerTotalDeductions(worker) {
      return worker.pre_tax_deductions + worker.post_tax_deductions;
    },
    calcWorkerTotal(worker) {
      let totalAdds = this.calcWorkerTotalAdditions(worker);
      let totalDeds = this.calcWorkerTotalDeductions(worker);
      return worker.total_pay_amount + totalAdds - totalDeds;
    },
    calcTotalAdditions() {
      let total = 0;
      if (this.$store.state.client_timesheets.timesheet_preview_info !== null) {
        this.$store.state.client_timesheets.timesheet_preview_info.forEach(timesheet_preview => {
          total += timesheet_preview.pre_tax_adds;
          total += timesheet_preview.post_tax_adds;
        })
      }
      return total;
    },
    calcTotalDeductions() {
      let total = 0;
      if (this.$store.state.client_timesheets.timesheet_preview_info !== null) {
        this.$store.state.client_timesheets.timesheet_preview_info.forEach(timesheet_preview => {
          total += timesheet_preview.pre_tax_deductions;
          total += timesheet_preview.post_tax_deductions;
        })
      }
      return total;
    },
    getLocationTotal(location) {
      let total = 0;
      if (this.$store.state.client_timesheets.timesheet_preview_info !== null) {
        this.$store.state.client_timesheets.timesheet_preview_info.forEach(timesheet_preview => {
          if (timesheet_preview.timesheet_location === location) {
            total += timesheet_preview.total_pay_amount
          }
        })
      }
      return total
    },
    getImportTotal() {
      let total = 0;
      let totalAdds = this.calcTotalAdditions();
      let totalDeds = this.calcTotalDeductions();

      if (this.$store.state.client_timesheets.timesheet_preview_info !== null) {
        this.$store.state.client_timesheets.timesheet_preview_info.forEach(timesheet_preview => {
          total += timesheet_preview.total_pay_amount
        })
      }

      return total + totalAdds - totalDeds;
    },
    cancelImport() {
      this.hideModal();
    },
    importTimesheets() {
      this.$parent.import_timesheet_file(this.payWorkerFee);
      this.$nextTick(() => this.hideModal());
    }
  }
}
</script>

<style lang="scss">
@media (min-width: 576px) {
  #preview_timesheet_file_modal {
    .modal-dialog {
      max-width: 900px;
    }
  }
}

#preview_timesheet_file_modal {
  th.rotate {
    .capsule {
      width:      50px;
      position:   relative;
      background: transparent;

      span {
        transform: translate(-10px, -105px) rotate(-60deg);
        position:  absolute;
        width:     200px;
      }
    }
  }

  .preview-container {
    overflow: scroll;

    table {
      thead {
        th {
          height: 200px;
        }
      }

      tbody {
        tr {
          td {
            vertical-align: middle;

          }
        }
      }

      tfoot {
        border-top: #999999 2px solid;

        th, td {
          vertical-align: middle;
          padding:        0 0.3rem;
        }
      }
    }
  }
}
</style>
